<template>
  <vbt-dialog
    v-model="dialog"
    :title="title"
    :submit-btn-name="submitBtnName"
    @submit="submitForm"
    @close="resetFormValidation"
  >
    <v-form :ref="ref">
      <v-layout align-center>
        <v-flex lg10>
          <v-text-field
            v-model.trim="form.name"
            :rules="validator.getRulesByField('name')"
            label="Name"
            @keypress.enter="submitForm"
          />
        </v-flex>
        <v-spacer />
        <v-checkbox
          v-model="form.shippingBox"
          label="Shipping Box"
        />
      </v-layout>
      <v-layout>
        <v-select
          v-model="form.sizeUnits"
          :rules="validator.getRulesByField('sizeUnits')"
          :items="boxUnits"
          label="Box Unit"
          class="mr-2"
        />
        <v-select
          v-model="form.boxType"
          :rules="validator.getRulesByField('boxType')"
          :items="boxTypes"
          label="Box Type"
        />
      </v-layout>
      <vbt-section title="Inner dimensions">
        <v-text-field
          v-model.trim.number="form.innerHeight"
          :rules="validator.getRulesByField('innerHeight')"
          label="Height"
          class="mr-2"
          @keypress.enter="submitForm"
        />
        <v-text-field
          v-model.trim.number="form.innerLength"
          :rules="validator.getRulesByField('innerLength')"
          label="Length"
          class="mr-2"
          @keypress.enter="submitForm"
        />
        <v-text-field
          v-model.trim.number="form.innerWidth"
          :rules="validator.getRulesByField('innerWidth')"
          label="Width"
          @keypress.enter="submitForm"
        />
      </vbt-section>
      <vbt-section title="Outer dimensions">
        <v-text-field
          v-model.trim.number="form.outerHeight"
          :rules="validator.getRulesByField('outerHeight')"
          label="Height"
          class="mr-2"
          @keypress.enter="submitForm"
        />
        <v-text-field
          v-model.trim.number="form.outerLength"
          :rules="validator.getRulesByField('outerLength')"
          label="Length"
          class="mr-2"
          @keypress.enter="submitForm"
        />
        <v-text-field
          v-model.trim.number="form.outerWidth"
          :rules="validator.getRulesByField('outerWidth')"
          label="Width"
          @keypress.enter="submitForm"
        />
      </vbt-section>
    </v-form>
  </vbt-dialog>
</template>

<script>
import { mapState } from 'vuex';

import { useDialog, useEditor, useFormWithRef } from '@mixins/factories';

import { Validator, wrapToLoadingFn } from '@helpers';

import { namespace as EnumsNamespace } from '@store/modules/enums.types';
import { namespace as LocationsNamespace } from '@store/modules/locations.types';

import BoxTypesApiService from '../_services/boxTypes.api.service';

import { generateBoxTypeModel } from '../_models/boxType.model';

const validator = Validator.createValidator({
  name: ['required'],
  boxType: ['required'],
  sizeUnits: ['required'],
  innerHeight: ['required', 'number'],
  innerLength: ['required', 'number'],
  innerWidth: ['required', 'number'],
  outerHeight: ['required', 'number'],
  outerLength: ['required', 'number'],
  outerWidth: ['required', 'number'],
});

export default {
  name: 'KernelBoxTypeEditor',
  mixins: [
    useDialog(),
    useFormWithRef(),
    Validator.useValidator(validator),
    useEditor({ formGenerator: generateBoxTypeModel }),
  ],
  computed: {
    ...mapState(LocationsNamespace, ['suffix']),
    ...mapState(EnumsNamespace, {
      boxTypes: ({ enums: { boxType: enums } }) => (enums || []).map(({ value }) => value),
      boxUnits: ({ enums: { boxUnits: enums } }) => (enums || []).map(({ value }) => value),
    }),
    title() {
      return this.creator ? 'Create box type' : `Edit ${this.item.boxType} ${this.item.name}`;
    },
    action() {
      return this.creator ? BoxTypesApiService.createBoxType : BoxTypesApiService.updateBoxType;
    },
    submitPromptText() {
      return this.creator ? 'Create box type?' : `Update box type ${this.item.name}`;
    },
  },
  methods: {
    wrapToLoadingFn,
    submitForm() {
      if (!this.validateForm()) {
        return;
      }
      this.$VBlackerTheme.alert.warning({
        text: this.submitPromptText,
      }, () => this.wrapToLoadingFn({
        req: this.action.bind({}, {
          suffix: this.suffix,
          name: this.item.name,
          data: this.form,
        }),
        loadingSpinnerType: 'fullscreen',
        onSuccess: () => {
          this.$VBlackerTheme.notification.success(`Successfully ${
            this.creator ? 'created' : 'updated'
          }`);
          this.$emit('success');
          this.dialog = false;
        },
      }));
    },
  },
};
</script>
